const InfoPage = () => {
  return (
    <div className="py-10">
      {globalThis.window?.__version && (
        <p className="text-body">Version: {globalThis.window.__version}</p>
      )}
    </div>
  );
};

export default InfoPage;
